import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { useAdminSettings } from "@/hooks/useAdminSettings";
const Header = () => {
  const { settings } = useAdminSettings();
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handlePhoneClick = () => {
    // Fire GTM event for call click
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'cta_call_click'
      });
    }
    const telNumber = (settings as any)?.phone_number ? (settings as any).phone_number.replace(/\s+/g, '') : '+4915754767196';
    window.location.href = `tel:${telNumber}`;
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b-2 md:border-b-4 border-[#D7982B] transition-all duration-300 ${isScrolled ? 'bg-opacity-70' : 'bg-opacity-90'}`} style={{
    backgroundColor: `rgba(27, 33, 57, ${isScrolled ? 0.70 : 0.90})`
  }}>
      <div className="w-full px-3 sm:px-4 lg:px-6 py-3">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center space-x-3 flex-shrink-0">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center shadow-lg relative" style={{
            backgroundColor: '#D9992B'
          }}>
              {/* Unique geometric design instead of T */}
              <div className="relative w-6 h-6">
                <div className="absolute inset-0 border-2 border-[#F4F4F4] rounded-sm transform rotate-45"></div>
                <div className="absolute top-1/2 left-1/2 w-2 h-2 bg-[#F4F4F4] rounded-full transform -translate-x-1/2 -translate-y-1/2"></div>
              </div>
            </div>
            <div className="flex flex-col">
              <span className="text-xl md:text-2xl font-bold text-[#F4F4F4] leading-tight uppercase">{(settings as any)?.website_name || 'Vintage Fiasco'}</span>
              <span className="text-xs text-[#D9992B] font-medium leading-tight -mt-0.5">{(settings as any)?.website_tagline || 'Wholesale Delivery at Your Doorstep'}</span>
            </div>
          </div>

          {/* Phone number display */}
          <div onClick={handlePhoneClick} className="flex items-center gap-2 bg-[#D9992B] hover:bg-[#B8822A] text-[#F4F4F4] px-2 sm:px-3 py-2 rounded-lg cursor-pointer transition-all duration-300 hover:scale-105 shadow-lg flex-shrink-0">
            <Phone className="w-4 h-4" />
            <span className="text-sm font-semibold whitespace-nowrap">{(settings as any)?.phone_number || '+49 15754767196'}</span>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;